import { render, staticRenderFns } from "./fourth.vue?vue&type=template&id=32d665f6&scoped=true"
import script from "./fourth.vue?vue&type=script&lang=js"
export * from "./fourth.vue?vue&type=script&lang=js"
import style0 from "./fourth.vue?vue&type=style&index=0&id=32d665f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d665f6",
  null
  
)

export default component.exports